// src/menu-items/statistics.ts
import { Barcode } from 'iconoir-react';


const vouchers = {
  id: 'vouchers-group',
  title: 'Vouchers',
  type: 'group',
  children: [
    {
      id: 'vouchers-create',
      title: 'Create / Validate Voucher',
      type: 'item',
      url: '/vouchers/add',
      icon: Barcode,
      breadcrumbs: true
    }
  ]
};

export default vouchers;